export const CandidateHaveBack = Object.freeze({
  /**
   * Yes, have the candidate back.
   */
  YES: 1,
  /**
   *  No, don't have the candidate back. (Set candidate as non-preferred)
   */
  NO: 2,
  /**
   * Yes, also set the candidate as preferred.
   */
  PREFERRED: 3,
})
